<template>
  <!-- modal cadastro -->
  <b-modal id="modal-cadastrar-simulado" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title">Cadastrar simulado</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-cadastrar-simulado')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <form>
      <h6><i class="fas fa-user-tag"></i> Dados do simulado</h6>
      <div class="row">
        <div class="col-12 col-md-12">
          <div class="form-group">
            <label for="nome">Nome do simulado</label>
            <form-group id="nomeSimulado" label="Nome do simulado" label-class="sr-only" :text="{ required: 'Obrigatório informar o nome do simulado' }" :field="$v.simulado.simulado">
              <input type="text" class="form-control" id="nome" placeholder="" v-model="simulado.simulado" />
            </form-group>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="tempoPrevisto">Tempo previsto(min)</label>
            <form-group id="tempoPrevisto" label="Tempo previsto(min)" label-class="sr-only" :text="{ required: 'Obrigatório informar o tempo previsto' }" :field="$v.simulado.tempoPrevisto">
              <input type="number" min="1" max="999" class="form-control"  name="tempoPrevisto" placeholder="" v-model="simulado.tempoPrevisto" />
            </form-group>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="ano">Ano </label>
            <form-group id="ano" label="Ano" label-class="sr-only" :text="{ required: 'Obrigatório informar o Ano' }" :field="$v.simulado.ano">
              <input type="number" min="1950" max="2050" class="form-control" name="ano" placeholder="" v-model="simulado.ano" />
            </form-group>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="fonte">Tipo de Simulado</label>
            <form-group id="tipo" label="tipo" label-class="sr-only" :text="{ required: 'Obrigatório informar o tipo do simulado' }" :field="$v.simulado.tipo_simulado_id">
              <select class="form-control" v-model="simulado.tipo_simulado_id">
                <option value="">Selecione</option>
                <option v-for="tipo in tipoSimulados" :key="tipo.id" :value="tipo.id">{{ tipo.descricao }}</option>
              </select>
            </form-group>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="fonte">Curso</label>
            <form-group id="curso" label="curso" label-class="sr-only" :text="{ required: 'Obrigatório informar o tipo do simulado' }" :field="$v.simulado.curso_id">
              <select class="form-control" v-model="simulado.curso_id">
                <option value="">Selecione</option>
                <option v-for="curso in cursos" :key="curso.id" :value="curso.id">{{ curso.curso }}</option>
              </select>
            </form-group>
          </div>
        </div>

        <div class="col-12 col-md-12">
          <div class="form-group">
            <label for="publico">Público Alvo</label>
            <select class="form-control" id="publico" v-model="simulado.publico_id">
              <option value="">Selecione</option>
              <option v-for="publico in publicoAlvo" :key="publico.id" :value="publico.id">{{ publico.publico }}</option>
            </select>
          </div>
        </div>

        <div class="col-12 col-md-12" v-if="fontesFiltradas && fontesFiltradas.length > 0">
          <div class="form-group">
            <label for="fonte">Fonte</label>
            <select class="form-control" id="fonte" v-model="simulado.fonte_id">
              <option value="">Selecione</option>
              <option v-for="fonte in fontesFiltradas" :key="fonte.id" :value="fonte.id">{{ fonte.descricao }}</option>
            </select>
          </div>
        </div>

        <div class="col-12 col-md-12" v-if="modalidadesDisponiveis && modalidadesDisponiveis.length > 0">
          <div class="form-group">
            <label for="modalidade">Modalidade</label>
            <select class="form-control" id="modalidade" v-model="simulado.modalidade_id">
              <option value="">Selecione</option>
              <option v-for="modalidade in modalidadesDisponiveis" :key="modalidade.id" :value="modalidade.id">{{ modalidade.descricao }}</option>
            </select>
          </div>
        </div>
      </div>

      <h6><i class="fas fa-user-tag"></i>
        Definir data do relatório <i class="fas fa-question-circle" id="tooltip-target-1"></i>
      </h6>
      <b-tooltip target="tooltip-target-1" triggers="hover">
        <strong>Acompanhe seus alunos</strong><br>Receba um e-mail com o relatório deste simulado. O email chegará às 21h no dia da data de recebimento.
      </b-tooltip>
      <div class="row">
        <div class="col-12 col-md-12">
          <div class="form-group">
            <label for="email">E-mail</label>
            <form-group id="emailRelatorio" label="Email do professor" label-class="sr-only" :text="{ required: 'Obrigatório informar o e-mail do professor' }" :field="$v.simulado.email">
              <input type="email" class="form-control" id="email" placeholder="" v-model="simulado.email" />
            </form-group>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="descricao">Descrição</label>
            <form-group id="descricao" label="Descrição" label-class="sr-only" :text="{ required: 'Obrigatório informar a descrição' }" :field="$v.simulado.descricao">
              <input type="text" class="form-control" id="descricao" placeholder="" v-model="simulado.descricao" />
            </form-group>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="dataRecebimento">Data de recebimento </label>
            <form-group id="dataRecebimento" label="Ano" label-class="sr-only" :text="{ required: 'Obrigatório informar a data de recebimento' }" :field="$v.simulado.data_recebimento">
              <input type="date" class="form-control" name="dataRecebimento" placeholder="" v-model="simulado.data_recebimento" />
            </form-group>
          </div>
        </div>
      </div>

      <h6><i class="fas fa-user-tag"></i> Questões</h6>
      <template>
        <div class="row">
          <div class="col-md-2">
            <p>Ordem</p>
          </div>
          <div class="col-md-10">
            <p>Nome</p>
          </div>
        </div>
        <div v-for="(questao, index) in questoesBase" class="row" v-bind:key="questao.id">
          <div class="col-12 col-md-2">
            <div class="form-group">
              <input @change="alteraOrdem(questao)" type="number" class="form-control" placeholder="" :value="index+1" />
            </div>
          </div>
          <div class="col-12 col-md-10">
            <div class="form-group">
              <input type="text" class="form-control" placeholder="" :value="questao.questao" readonly/>
            </div>
          </div>
        </div>
      </template>
      <div class="text-center">
        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
          <button class="btn btn-primary mr-3" type="button" @click="cadastrarSimulado" >Cadastrar</button>
          <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-cadastrar-simulado')">Cancelar</a>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import SimuladoAPI from '@/api/simulado-api'
import Swal from 'sweetalert2'
import ResponseUtils from '@/core/util/response-utils'
import { required, requiredIf } from 'vuelidate/lib/validators'
import FormGroup from '@/core/components/FormGroup'

export default {
  name: 'ModalCadastroSimulado',
  components: { FormGroup },
  props: {
    questoesSelecionadas: Array,
    modalidades: Array,
    publicoAlvo: Array,
    tipoSimulados: Array,
    cursos: Array,
    fontes: Array
  },
  data () {
    return {
      ordemQuestao: '',
      questoesBase: [],
      simulado: {
        ano: '2020',
        curso_id: '',
        fonte_id: '',
        simulado: '',
        publico_id: '',
        tempoPrevisto: '0',
        modalidade_id: '',
        tipo_simulado_id: '',
        email: '',
        descricao: '',
        data_recebimento: ''
      }
    }
  },

  watch: {
    questoesSelecionadas () {
      this.questoesBase = this.questoesSelecionadas
    }
  },

  computed: {

    modalidadesDisponiveis: function () {
      return this.modalidades.filter(modalidade => (
        modalidade.publico.id === this.simulado.publico_id &&
        modalidade.fonte.id === this.simulado.fonte_id
      ))
    },

    fontesFiltradas: function () {
      let modalidadesIds = []
      this.modalidades.map(modalidade => {
        modalidade.publico.id === this.simulado.publico_id &&
        modalidadesIds.push(modalidade.fonte.id)
      })
      return this.fontes.filter(fonte => {
        return modalidadesIds.includes(fonte.id)
      })
    },

    questoes: function () {
      return this.questoesBase
    },

    questoesInput: function () {
      let retorno = []
      this.questoes.map(questao => {
        retorno.push(questao.id)
      })
      return retorno
    }
  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.$v.$reset()
      this.simulado = {
        ano: '2020',
        curso_id: '',
        fonte_id: '',
        simulado: '',
        publico_id: '',
        tempoPrevisto: '0',
        modalidade_id: '',
        tipo_simulado_id: ''
      }
    })
    this.questoesBase = this.questoesSelecionadas
  },

  validations: {
    simulado: {
      simulado: { required },
      tempoPrevisto: { required },
      ano: { required },
      curso_id: { required },
      tipo_simulado_id: { required },
      email: {
        required: requiredIf(function (simulado) {
          return simulado.descricao || simulado.data_recebimento
        })
      },
      descricao: {
        required: requiredIf(function (simulado) {
          return simulado.email || simulado.data_recebimento
        })
      },
      data_recebimento: {
        required: requiredIf(function (simulado) {
          return simulado.email || simulado.descricao
        })
      }
    }
  },

  methods: {
    alteraOrdem: function (questao) {
      let indexSelected = event.target.value - 1
      if (indexSelected >= 0) {
        // Remove a questao da lista
        this.questoesBase = this.questoesBase.filter((item, index) => (
          item !== questao
        ))
        // Adiciona na posicao selecionada
        this.questoesBase.splice(indexSelected, 0, questao)
      }
    },
    show: function () {
      this.$bvModal.show('modal-cadastrar-simulado')
    },

    cadastrarSimulado: function () {
      this.$v.simulado.$touch()
      if (!this.$v.simulado.$invalid) {
        this.simulado.questoes = this.questoesInput
        const loader = this.$loading.show()

        SimuladoAPI.salvar(this.simulado).then(data => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Simulado criado com sucesso'
          }).then(() => {
            this.$bvModal.hide('modal-cadastrar-simulado')
            this.$emit('simuladoSalva', this.simulado)
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    }
  }
}
</script>
